{
	"cardHeader": "Достъп до вашите декларации",
	"supplierTitle": "Вие сте доставчикът на декларация evoZero?",
	"supplierDescription": "Управлявайте декларациите за вашите материали evoZero.",
	"loginButton": "Вход"
}
